import {
  WorkflowsEdge,
  WorkflowsExpression,
  WorkflowsNode,
  WorkflowsValueObjectsNodeTypeEnum,
} from 'generated/resources/graphql'

export type BackendStartNodeData = Record<string, never> // Start node has no data

export type BackendSwitchComparison = {
  label: string
  priority: number
  expression: WorkflowsExpression
}

export type BackendSwitchNodeData = {
  _type: 'switch_data'
  comparisons: BackendSwitchComparison[]
}

export type BackendActionNodeData = {
  _type: 'action_data'
  payload: Record<string, unknown>
  handler_name: string
}

export type BackendTerminateNodeData = Record<string, never>

export type BackendNode =
  | BackendActionNode
  | BackendSwitchNode
  | BackendStartrNode
  | BackendTerminateNode
export type BackendEdge = WorkflowsEdge

type BackendBaseNode = Omit<WorkflowsNode, 'hackExposeExpressions' | 'data'> & {
  nodeType: WorkflowsValueObjectsNodeTypeEnum
}

export type BackendSwitchNode = BackendBaseNode & {
  nodeType: 'switch'
  data: BackendSwitchNodeData
}

export type BackendActionNode = BackendBaseNode & {
  nodeType: 'action'
  data: BackendActionNodeData
}

export type BackendStartrNode = BackendBaseNode & {
  nodeType: 'start'
  data: BackendStartNodeData
}

export type BackendTerminateNode = BackendBaseNode & {
  nodeType: 'terminate'
  data: BackendTerminateNodeData
}

export const isBackendTerminateNode = (node: BackendNode): node is BackendTerminateNode => {
  return node.nodeType === 'terminate'
}

export const isBackendStartNode = (node: BackendNode): node is BackendStartrNode => {
  return node.nodeType === 'start'
}

export const isBackendActionNode = (node: BackendNode): node is BackendActionNode => {
  return node.nodeType === 'action'
}

export const isBackendSwitchNode = (node: BackendNode): node is BackendSwitchNode => {
  return node.nodeType === 'switch'
}

// Union type for all backend node data types
export type BackendNodeData = BackendSwitchNodeData | BackendActionNodeData | BackendStartNodeData

// Type guard for BackendSwitchNodeData
export const isBackendSwitchNodeData = (data: BackendNodeData): data is BackendSwitchNodeData => {
  return data._type === 'switch_data'
}
